// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__10GKz","footer":"Form_footer__1Gx2u"};